import axiosInstance from './axios';
import { SPEECH_TOKEN } from './api_routes';

export async function fetchSpeechToken() {
    const response = await axiosInstance.get(SPEECH_TOKEN);
    return response.data;
}
